/* Orden cronológico real dentro del grupo "En evaluación" (Aprobado -> Validado -> Firmado,
   confirmado por Contract.tsx: el formulario de contrato se llena en Validado(4), y al firmar
   pasa a Firmado(3) — el id numérico no refleja el orden real del flujo).
   Firmado no es 100%: todavía falta "Recepción" (id_status pasa a 5 recién ahí, momento en
   que el tradein se mueve solo al KPI "Finalizados"), por eso el tope acá es 90%, no 100%.
   Solo usa id_status (siempre disponible en la tabla), sin depender de sub-etapas ni de
   columnas extra en el backend. */
const EVALUACION_PROGRESS: Record<number, number> = {
  2: 30, // Aprobado
  4: 60, // Validado
  3: 90 // Firmado — pendiente Recepción
}

export const getTradeinProgressPercent = (item: any): number => {
  return EVALUACION_PROGRESS[item.id_status] ?? 0
}
